import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { login } from '../../services/Auth/actions';
import LoginForm from '../../forms/Login';

const Title = styled.h1`
  text-align: center;
`;

const MaterialCard = styled.div`
  padding: 20px;
  background-color: #F1F4F4; /* White */
  border: 1px solid black;
  width: 100%;
  margin-top: 20px;
`;

class Login extends Component {
  onLogin = (values) => {
    const { email, password } = values;
    this.props.login(email, password, () => {
      this.props.history.push('/home');
    });
  }

  render() {
    const {
      Auth: {
        isLoading,
      },
    } = this.props;

    return (
      <Container>
        <Row>
          <Col md={{ size: 8, offset: 2 }} xs={{ size: 10, offset: 1 }}>
            <div className="d-flex flex-column justify-content-center align-items">
              <MaterialCard>
                <Title>
                  <FormattedMessage id="Pages.Home.Title" />
                </Title>
                <LoginForm
                  onSubmit={this.onLogin}
                  isLoading={isLoading}
                />
              </MaterialCard>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  Auth: state.Auth,
});

const mapDispatchToProps = {
  login,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
